import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0066',
    ecrans: ['00-2'],
    params: ['?caecleint']
});
